import { DEFAULT_TEXT_SIZE } from '@_/theme/constants.ts';

export function UIProvider({ children }: React.PropsWithChildren) {
  return <div className={DEFAULT_TEXT_SIZE}>{children}</div>;
}
